var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_135_939)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3801 1.40295H6.15651C5.18848 1.40295 4.40283 2.1886 4.40283 3.15663V14.3802C4.40283 15.3482 5.18848 16.1339 6.15651 16.1339H17.3801C18.3481 16.1339 19.1337 15.3482 19.1337 14.3802V3.15663C19.1337 2.1886 18.3481 1.40295 17.3801 1.40295ZM8.9624 7.01473V13.6787H6.85798V7.01473H8.9624ZM6.85798 5.07516C6.85798 4.58413 7.27887 4.20884 7.91019 4.20884C8.54152 4.20884 8.93785 4.58413 8.9624 5.07516C8.9624 5.56619 8.56958 5.96252 7.91019 5.96252C7.27887 5.96252 6.85798 5.56619 6.85798 5.07516ZM16.6786 13.6787H14.5742C14.5742 13.6787 14.5742 10.4309 14.5742 10.1714C14.5742 9.46988 14.2234 8.76841 13.3466 8.75438H13.3185C12.4698 8.75438 12.119 9.4769 12.119 10.1714C12.119 10.4905 12.119 13.6787 12.119 13.6787H10.0146V7.01473H12.119V7.91262C12.119 7.91262 12.7959 7.01473 14.1568 7.01473C15.5492 7.01473 16.6786 7.97224 16.6786 9.91181V13.6787Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_135_939",
    x: -1,
    y: 0,
    width: 25.5366,
    height: 25.5369,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_135_939"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_135_939",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.66137556353acf223d2068dffcb45909.svg";
export { ForwardRef as ReactComponent };